export enum RegistrationTestHooks {
  RegisterAnotherAppliancePanelButton = 'register-another-appliance-panel-button',
  RegistrationBenefitsPanel = 'registration-benefits-panel',
  RegistrationProgressionSteps = 'registration-progression-steps',
  RegistrationConfirmationPanel = 'registration-confirmation-panel',
}
